import { render } from "./CreateTeamButton.vue?vue&type=template&id=49d0beb0"
import script from "./CreateTeamButton.vue?vue&type=script&lang=js"
export * from "./CreateTeamButton.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__